import $ from 'jquery';

$(() =>
  $('body.resource_user #user_all_systems')
    .change(evt => $('.user_systems').toggle(!evt.currentTarget.checked))
    .change()
);
